if (!customElements.get('cookie-banner')) {
  customElements.define(
    'cookie-banner',
    class CookieBanner extends ModalElement {
      constructor() {
        super();
    
        if (!theme.config.isTouch || Shopify.designMode) {
          this.init();
        }
        else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }
    
      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }
    
      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
      }
    
      get acceptButton() {
        return this.querySelector('button[name="accept"]');
      }
    
      get preferencesButton() {
        return this.querySelector('button[name="preferences"]');
      }

      get preferencesPanel() {
        return document.getElementById('CookiePreferences');
      }

      init() {
        if (this.initialized) return;
        this.initialized = true;

        if (!this.testMode && localStorage.getItem('cookie_banner_dismissed')) return;

        window.Shopify.loadFeatures([{
          name: 'consent-tracking-api',
          version: '0.1',
          onLoad: this.onConsentLibraryLoaded.bind(this)
        }]);
      }
    
      load(delay) {
        if (this.acceptButton) this.acceptButton.addEventListener('click', this.acceptPolicy.bind(this));
        if (this.preferencesButton) this.preferencesButton.addEventListener('click', this.openPreferences.bind(this));
        this.initPreferencesPanel();

        if (Shopify.designMode) return;
        setTimeout(() => this.show(), delay * 1000);
      }

      acceptPolicy() {
        this.hide();
        localStorage.setItem('cookie_banner_dismissed', 'accepted');
        window.Shopify.customerPrivacy?.setTrackingConsent({
          analytics: true,
          marketing: true,
          preferences: true,
          sale_of_data: true
        }, this.noop);
      }

      openPreferences() {
        const panel = this.preferencesPanel;
        if (!panel) return;
        panel.removeAttribute('hidden');
        document.body.classList.add('has-cookie-preferences');
      }

      closePreferences() {
        const panel = this.preferencesPanel;
        if (!panel) return;
        panel.setAttribute('hidden', '');
        document.body.classList.remove('has-cookie-preferences');
      }

      initPreferencesPanel() {
        const panel = this.preferencesPanel;
        if (!panel) return;

        panel.querySelectorAll('[data-pref-close]').forEach(el => {
          el.addEventListener('click', this.closePreferences.bind(this));
        });

        panel.querySelector('button[name="pref-accept-all"]')?.addEventListener('click', () => {
          this.savePreferences(true, true, true);
        });

        panel.querySelector('button[name="pref-decline-all"]')?.addEventListener('click', () => {
          this.savePreferences(false, false, false);
        });

        panel.querySelector('button[name="pref-save"]')?.addEventListener('click', () => {
          const preferences = panel.querySelector('#pref-personalization')?.checked ?? false;
          const marketing = panel.querySelector('#pref-marketing')?.checked ?? false;
          const analytics = panel.querySelector('#pref-analytics')?.checked ?? false;
          this.savePreferences(preferences, marketing, analytics);
        });

        const saved = localStorage.getItem('cookie_preferences');
        if (saved) {
          try {
            const choices = JSON.parse(saved);
            const pref = panel.querySelector('#pref-personalization');
            const mkt = panel.querySelector('#pref-marketing');
            const ana = panel.querySelector('#pref-analytics');
            if (pref) pref.checked = choices.preferences ?? false;
            if (mkt) mkt.checked = choices.marketing ?? false;
            if (ana) ana.checked = choices.analytics ?? false;
          } catch (e) {}
        }
      }

      savePreferences(preferences, marketing, analytics) {
        this.closePreferences();
        this.hide();
        localStorage.setItem('cookie_banner_dismissed', 'modified');
        localStorage.setItem('cookie_preferences', JSON.stringify({ preferences, marketing, analytics }));
        window.Shopify.customerPrivacy?.setTrackingConsent({
          analytics,
          marketing,
          preferences,
          sale_of_data: marketing
        }, this.noop);
      }

      onConsentLibraryLoaded() {
        this.load(this.delay);
      }
    
      noop() {
      }
    
      afterHide() {
        super.afterHide();
        document.body.classList.remove('has-cookie-banner');
      }
      afterShow() {
        super.afterShow();
        document.body.classList.add('has-cookie-banner');
      }
    }
  );
}
